export const bigQueryGuest = (type) => ({
    group: 'header_clicks',
    type: `clicked_header.${type}`,
});
